import {Widget} from "../../Contracts/WidgetTypes";
import {WidgetLocationRaw} from "../../Composables/WidgetNavigation/contracts";
import {useWidgetNavigation} from "../../Composables/WidgetNavigation/useWidgetNavigation";

export const WIDGET_STATE_EVENTS = {
    WIDGET_NAVIGATION_CHANGED: 'widget_navigation_changed',
    WIDGET_MOUNTED: 'widgetMounted',
    WIDGET_UNMOUNTED: 'widgetUnmounted',
    WIDGET_ELEMENT_CLICK: 'widgetElementClick',
    WIDGET_MOUNTED_WITH_SUPPLIER_ID: 'widgetMountedWithSupplierId',
    WIDGET_OPEN_CHECKOUT: 'widgetOpenCheckout',
} as const;

type WidgetNavigation = ReturnType<typeof useWidgetNavigation<any>>;

export type WidgetStateEventConstructor = {
    [WIDGET_STATE_EVENTS.WIDGET_MOUNTED]: {widgetNavigation: WidgetNavigation},
    [WIDGET_STATE_EVENTS.WIDGET_UNMOUNTED]: Record<string, never>,
    [WIDGET_STATE_EVENTS.WIDGET_NAVIGATION_CHANGED]: WidgetLocationRaw,
    [WIDGET_STATE_EVENTS.WIDGET_ELEMENT_CLICK]: { element: string, elementType: ClickEventElement },
    [WIDGET_STATE_EVENTS.WIDGET_MOUNTED_WITH_SUPPLIER_ID]: any,
    [WIDGET_STATE_EVENTS.WIDGET_OPEN_CHECKOUT]: { url: string; preferWidgetId?: string },
}

export type WidgetStateEvents = {
    [K in keyof WidgetStateEventConstructor]: WidgetStateEventConstructor[K]
        & {widget: Widget, hostElement?: HTMLElement | null};
};